import { configureStore } from '@reduxjs/toolkit';
// import your reducers here
import videoReducer from '../features/videoPlayer/videoPlayer.slice';
import accountReducer from '../features/account/account.slice';

export const store = configureStore({
  reducer: {
    videoPlayer: videoReducer,
    account: accountReducer,
  },
});